// i18n area 'apps' — locale lv-LV (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.lv-LV.meta.json.
import type { enUS } from './apps'

export const lvLV: typeof enUS = {

  // Apps wave 1 (Annex R): pārvaldīti podman konteineri — worker tos uzrauga
  // uz deklarēta mezgla; attēls = lockfile branch@digest (Annex Q) ar
  // pinned/tracking politiku; untagged L3 pieslēgums ar statisku IP.
  apps: {
    title: 'Lietotnes',
    create: 'Izveidot lietotni',
    createTitle: 'Izveidot lietotni',
    editTitle: 'Rediģēt lietotni',
    name: 'Nosaukums',
    nameHint: 'DNS-1123, unikāls scope ietvaros — pēc izveides nemaināms.',
    node: 'Mezgls',
    nodeHint: 'Dalībnieka mezgls, kas to apkalpo — skaidri norādīts izvietojums (plānotājs būs vēlāk).',
    image: 'Attēls',
    editImageHint: 'Jauna atsauce tiek atkārtoti atrisināta caur uzskaiti — tas ir pin/rollback žests.',
    imagePolicy: 'Politika',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digests mainās tikai pēc komandas.',
    policyTrackingHint: 'Automātisks rolling, kad atsvaidzināšana pārvieto branch.',
    archMovePolicy: 'Cross-arch pārvietošana',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Kas notiek, ja app tiek pārvietota uz citas arhitektūras mezglu: refuse atsaka pārvietošanu, reresolve no jauna atrisina lockfile no branch jaunajā arch — saturs mainās, un atbilde nosauc digest izmaiņu.',
    network: 'Tīkls',
    networkHint: 'Untagged L3 pieslēgums: loģisks fabric tīkls (ieteicams — gateway un DNS no tā vienotā avota), overlay tīkls vai kails host bridge (nav ieteicams).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'host bridge:',
    ipAssignment: 'IP piešķiršana',
    ipStatic: 'Statiska',
    ipAuto: 'Automātiska (IPAM)',
    ipAssignmentHint_static: 'Adresi norāda operators — tagad.',
    ipAssignmentHint_auto: 'IPAM izvēlas brīvu adresi no tīkla diapazoniem, kas rezervēti TVirt.',
    bridgeDiscouraged: 'Kails host bridge — NAV IETEICAMS: TVirt neko nezina par tā adresāciju, tāpēc gateway un DNS jānorāda ar roku. Ieteicamais ceļš ir loģisks fabric tīkls.',
    ip: 'IP',
    ipHint: 'Statisks IPv4 pieslēguma apakštīklā.',
    ipCidrHint: 'CIDR formā uz kaila bridge (piem., 192.168.1.10/24) — nav no kā atvasināt prefiksu.',
    gateway: 'Gateway',
    gatewayManualHint: 'Manuāli — kails bridge neko neatvasina.',
    dnsServers: 'DNS serveri',
    dnsManualHint: 'Manuāli, atdalīti ar komatu — vismaz viens.',
    rootKind: 'Root',
    rootEphemeral: 'īslaicīga',
    rootPersistent: 'pastāvīga',
    rootEphemeralHint: 'Tiek izveidota no attēla ikreiz, kad lietotni rada no jauna; atrodas klastera īslaicīgajā storage.',
    rootEphemeralHintNamed: 'Tiek izveidota no attēla ikreiz, kad lietotni rada no jauna; atrodas klastera īslaicīgajā storage ({name}).',
    rootPersistentHint: 'Pārdzīvo pārstartēšanu; atrodas izvēlētajā storage.',
    rootStorage: 'Root storage',
    editRootStorageHint: 'Root tiek izveidota no jauna jaunajā pūlā — esošie dati NEPĀRVIETOJAS paši no sevis.',
    volumes: 'Sējumi',
    volumeAdd: 'Pievienot sējumu',
    volumeName: 'Nosaukums',
    volumeMountPath: 'Montēšanas ceļš',
    volumeKind: 'Tips',
    volumeStorage: 'Storage',
    devices: 'Ierīces',
    deviceClassHint: 'Tiek prasīta KLASE (gpu-device vai usb-device birka), nekad konkrēta ierīce: deklarētajam mezglam jābūt tādai, kas atzīmēta lietotnēm. Vairākas lietotnes var izmantot vienu ierīci — konteineris to koplieto, tas neatņem to resursdatoram.',
    deviceSlot: 'Slots',
    deviceTag: 'Birka',
    deviceValue: 'Klase',
    deviceUnresolved: 'pašlaik nekas netiek atrisināts',
    noDeviceTags: 'Vēl nav gpu-device vai usb-device veida birkas: izveido to un piešķir ierīcēm, kas atzīmētas lietotnēm.',
    env: 'Vide',
    envHint: 'Viens ATSLĒGA=vērtība katrā rindā.',
    secretEnvTitle: 'Slepenie mainīgie',
    secretEnvNotice: 'Slepena vērtība no API vairs nekad neatgriežas: neviens to vairs neizlasa, pat ne tas, kurš to ierakstīja. Checkpoint tā ceļo ar masterpass aizzīmogota, tāpēc atjaunošana bez masterpass prasīs to ierakstīt no jauna.',
    secretEnvPromote: 'Padariet slepenu vienu no augstāk ierakstītajiem mainīgajiem:',
    secretEnvAdd: 'Pievienot slepenu mainīgo',
    secretEnvName: 'Nosaukums',
    secretEnvValue: 'Vērtība',
    secretEnvKept: 'saglabāta — atstājiet tukšu, lai to nemainītu',
    secretEnvWithdrawWarning: 'Lai pārstātu uzskatīt par slepenu mainīgo, kas jau tāds ir, ierakstiet tam jaunu vērtību: tikai atzīmes noņemšana būtu veids, kā IZLASĪT to, kas no store nekad neiziet. Turpretī mainīgā noņemšana to izdzēš.',
    secretEnvChip: 'slepens',
    startNow: 'Palaist uzreiz (citādi lietotne piedzimst apturēta)',
    deletePersistentIntro: 'Šai lietotnei ir pastāvīgi dati — jāizvēlas, ko ar tiem darīt:',
    deleteKeepData: 'Paturēt datus (direktorijas paliek savos storage, bez saimnieka)',
    deletePurgeData: 'Dzēst arī datus',
    phase: 'Fāze',
    phase_running: 'Darbojas',
    phase_stopped: 'Apturēta',
    phase_error: 'Kļūda',
    phase_unknown: 'Nezināma',
    desiredState: 'Vēlamais',
    wantedRunning: 'darbojas',
    wantedStopped: 'apturēta',
    start: 'Palaist',
    stop: 'Apturēt',
    restart: 'Pārstartēt',
    refreshImage: 'Atsvaidzināt attēlu (pārņemt jauno @current)',
    logs: 'Žurnāls',
    logsTitle: 'Žurnāls',
    logsEmpty: 'Nav uztverta neviena izvade.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App nedarbojas — shell ir vajadzīgs dzīvs konteiners. Tās žurnāli ir lasāmi jebkurā stāvoklī.',
    shellConnect: 'Pieslēgties',
    shellDisconnect: 'Atslēgties',
    shellExited: 'Sesija beidzās ar izejas kodu {code}.',
    shellEndedWithoutStatus: 'Sesija beidzās bez izejas statusa: {reason}',
    shellRevoked: 'Sesijas ticket vairs nav derīgs — tas beidzās, vai pieteikšanās, kas to atvēra, tika atsaukta.',
    shellHint: 'Noklikšķiniet melnajā laukā un rakstiet: taustiņi nonāk konteinerā. Ctrl+C un bultiņas darbojas; exit aizver shell.',
    shellStatus: {
      connecting: 'Pieslēdzas…',
      connected: 'Pieslēgta',
      ended: 'Beigusies'
    },
    deleteRunningError: '{name} ir iestatīta kā darbojoša — vispirms tā jāaptur.',

    // Standarta dialogs (kārta #156): detaļu cilnes un trūkstošie contract
    // lauki — katrs lietotnes lauks redzams, slēdzenes ar pamatojumu.
    tabs: {
      general: 'Vispārīgi',
      image: 'Attēls',
      network: 'Tīkls',
      storage: 'Storage',
      devices: 'Ierīces',
      observed: 'Novērotais'
    },
    attachment: 'Pieslēgums',
    runningDigest: 'Darbībā esošais digests',
    lastError: 'Pēdējā kļūda',
    reportObservedAt: 'Pēdējais worker ziņojums',
    desiredStateLock: 'To nosaka darbības Palaist un Apturēt — nekad tieša izmaiņa.',
    ipEditDisabledHint: 'Maināms tikai ar statisku piešķiršanu.',
    derivedFromNetworkHint: 'Atvasināts no tīkla vienotā avota — manuāli tikai uz kaila bridge ar statisku IP.',
    ephemeralUnset: 'nav konfigurēts',
    ephemeralMissing: 'Lietotņu īslaicīgais storage nav konfigurēts — lietotnes ar īslaicīgām daļām (root vai sējumiem) izveide tiek noraidīta, kamēr tas nav iestatīts.',
    ephemeralCurrent: 'Lietotņu īslaicīgais storage: {name}',
    ephemeralMissingCreate: 'Šai lietotnei ir īslaicīgas daļas, bet Lietotņu īslaicīgais storage nav iestatīts — izveide tiks noraidīta. Vispirms tas jāiestata Lietotņu lapas paziņojuma joslā.',
    setEphemeral: 'Iestatīt īslaicīgo storage',
    changeEphemeral: 'Mainīt īslaicīgo storage',
    setEphemeralTitle: 'Iestatīt Lietotņu īslaicīgo storage',
    changeEphemeralTitle: 'Mainīt Lietotņu īslaicīgo storage',
    ephemeralStorageHint: 'Klastera NOKLUSĒJUMS: dir tipa pūls, kurā mīt katras lietotnes īslaicīgās root un sējumi, ja vien lietotne nedeklarē override. Maiņa nenotiek darbības laikā un neko nepārstartē: tā stājas spēkā no katras lietotnes nākamās palaišanas — īslaicīgie dati netiek pārvietoti.',
    ephemeralPool: 'Storage pūls',
    ephemeralOverride: 'Īslaicīgais storage (override katrai lietotnei)',
    ephemeralOverrideInherit: 'Mantot klastera noklusējumu',
    ephemeralOverrideInheritNamed: 'Mantot klastera noklusējumu ({name})',
    ephemeralOverrideHint: 'Lietotnes pūls īslaicīgajām root un sējumiem — jāatstāj tukšs, lai mantotu klastera noklusējumu. Maiņa nenotiek darbības laikā un neko nepārstartē: tā stājas spēkā no nākamās palaišanas (īslaicīgie dati atdzimst tukši jaunajā pūlā) un prasa atļauju app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Visi zari',
    imageBranchHint: 'Sašaurina attēlus līdz tiem, ko nosauc šis zars; bez zara redzami visi repozitorija attēli.',
    imageDigestHint: 'Saturs: to izvēlas no digestu tabulas, kas nes tā izcelsmi un arhitektūru. Tas pats zars piedāvā pa vienam katrai arhitektūrai, un tie nav savstarpēji aizvietojami.',
    imageLockfile: 'Atrisinātā atsauce',
    imageNoImages: 'Šim repozitorijam kešatmiņā nav attēlu — lejupielādē vienu no OCI attēliem.',
    imageHeadNotCached: 'nav kešatmiņā — lejupielādē startējot',
    imageNoRegistries: 'Nav reģistrēts neviens repozitorijs: reģistrē vienu, lai varētu izvēlēties attēlu.',
    imageChosenHint: 'Attēlu izvēlas rediģēšanas dialoga kaskādē: atsauci nekad neraksta ar roku.',
    registerRepositoryHint: 'Reģistrēšana neko nelejupielādē: tā padara repozitoriju novērojamu, lai attēlu varētu izvēlēties, neizejot no šī dialoga.',
    registerRepositoryBranchHint: 'Neobligāti: pirmais novērojamais zars (piem., latest).',
    registerRepositoryElsewhere: 'Meklētais repozitorijs nav reģistrēts: reģistrēšana notiek sadaļā OCI attēli, to veic kāds ar atļauju.'
  },

  // CT template (kārta K2 #63): MATERIALIZĒTIE CT objekti — imports no
  // kataloga ir vienīgā ieeja; faili tiek augšupielādēti katalogos.
  cts: {
    createAction: 'Izveidot CT',
    createTitle: 'Izveidot konteineru no template',
    createError: 'Konteiners netika izveidots',
    template: 'CT template',
    noTemplates: 'Nav neviena CT template — jāimportē kāds no sadaļas CT template',
    resources: 'Resursi',
    node: 'Mezgls',
    phase: {
      defined: 'Nekad nav ieslēgts',
      materializing: 'Notiek materializācija',
      ready: 'Gatavs',
      starting: 'Notiek palaišana',
      running: 'Darbojas',
      stopping: 'Notiek apturēšana',
      stopped: 'Apturēts',
      deleting: 'Notiek dzēšana',
      error: 'Kļūdas stāvoklī'
    },
    actions: {
      start: 'Palaist',
      stop: 'Apturēt',
      restart: 'Pārstartēt',
      markTemplate: 'Paaugstināt par CT template',
      error: 'Darbība tika noraidīta'
    },
    markTemplate: {
      confirmTitle: "Paaugstināt '{name}' par CT template?",
      confirmBody: 'Konteiners pamet šo sarakstu un pāriet starp CT template, uzreiz gatavs radīt jaunus CT. Metadati paliek rediģējami, un to jebkurā brīdī var atgriezt par CT.',
      confirm: 'Paaugstināt',
      moved: "'{name}' tagad ir CT template — atrodams sadaļā CT template."
    },
    stopCause: {
      api: 'Apturēts no TVirt',
      'ct-exit': 'Konteiners izgāja pats',
      'host-reboot': 'Beidza pastāvēt līdz ar mezgla pārstartēšanu',
      'start-failed': 'Palaišana neizdevās — task kļūda pasaka, kā trūkst un kā to salabot'
    },

    console: 'Konsole',
    consoleUnavailable: 'Konteiners nedarbojas — konsolei vajadzīgs dzīvs konteiners. Tā žurnālu turpretī var lasīt jebkurā stāvoklī.',
    consoleNoTemplate: 'Template nekad nedarbojas, tāpēc tam nav konsoles: izveidojiet no tā CT un atveriet tā konsoli.',
    consoleConnect: 'Savienot',
    consoleDisconnect: 'Atvienot',
    consoleReconnect: 'Savienot atkārtoti',
    consoleTakenBy: 'Šo konsoli pārņēma cits operators ({user}). Viena konsole uz konteineru: atkārtota savienošana to atgriež jums.',
    consoleHint: 'Noklikšķiniet uz melnā laukuma un rakstiet: taustiņi nonāk konteinerā. Ctrl+C un bultiņas darbojas.',
    consoleEndpointDown: 'Konsoles piekļuves punktu nevar atvērt mezglā, kas apkalpo container: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container nedarbojas — shell vajag dzīvu container. Tā logus var lasīt jebkurā stāvoklī.',
    shellNoTemplate: 'Template nekad nedarbojas, tāpēc tam nav shell: izveidojiet no tā CT un atveriet tā shell.',
    shellConnect: 'Pieslēgties',
    shellDisconnect: 'Atslēgties',
    shellExited: 'Sesija beidzās ar izejas kodu {code}.',
    shellEndedWithoutStatus: 'Sesija beidzās bez izejas statusa: {reason}',
    shellRevoked: 'Sesijas ticket vairs nav derīgs — tas beidzās, vai pieteikšanās, kas to atvēra, tika atsaukta.',
    shellHint: 'Noklikšķiniet melnajā laukā un rakstiet: taustiņi nonāk konteinerā. Ctrl+C un bultiņas darbojas; exit aizver shell.',
    shellStatus: {
      connecting: 'Pieslēdzas…',
      connected: 'Pieslēgta',
      ended: 'Beigusies'
    },
    rootPassword: 'Root parole',
    rootPasswordHint: 'Tiek ierakstīta vienu reizi nokopētajā rootfs (kā hash, vairs netiek rādīta). Distribūciju image nav root paroles: bez tās shell ir vienīgā ieeja.',
    sshKeys: 'Root publiskās SSH atslēgas',
    sshKeysHint: 'Viena publiskā OpenSSH atslēga rindā, failā root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Notiek savienošana…',
      connected: 'Savienota',
      reconnecting: 'Notiek atkārtota savienošana…'
    },
    logs: 'Žurnāls',
    logsTitle: 'Žurnāls',
    logsEmpty: 'Nav uztverta neviena izvade.',
    logsSource: 'Kurš žurnāls',
    logsSourceConsole: 'Konteinera init konsole — kāpēc iekšienē esošais serviss nesāka darboties',
    logsSourceSupervisor: 'liblxc supervizors — kāpēc konteiners nemaz netika līdz darbībai',
    logsNeverStarted: 'Tas nekad nav palaists, tāpēc vēl nekas nav ierakstīts — palaidiet to, un žurnāls būs pat tad, ja palaišana neizdosies.',
    logsNoTemplate: 'Template nekad nedarbojas, tāpēc tas nekad neko nav ierakstījis.',
    logsError: 'Žurnālu neizdevās uztvert',

    // Standarta dialogs (kārta #156): detaļu cilnes, kopīgas CT un CT
    // template sarakstiem, plus slēdzenes ar pamatojumu.
    tabs: {
      general: 'Vispārīgi',
      hardware: 'Aparatūra',
      network: 'Tīkls',
      provenance: 'Izcelsme'
    },
    templateFlag: 'CT template',
    templateLock: 'Maināms tikai ar darbībām Paaugstināt un Atgriezt par CT — nekad tieša izmaiņa.',
    sourceLock: 'Izcelsme, reģistrēta piedzimstot — nekad netiek pārrakstīta; miris avots atstāj kailu atsauci.',
    storageLock: 'Fiksēts izveides brīdī — rootfs pārvietošana ir nākotnes kārtas jautājums.',
    startedAt: 'Palaists',
    lastStop: 'Pēdējā apturēšana',
    editNicsTitle: 'Rediģēt tīklus',
    nicDisconnected: 'atvienota'
  },
  ctTemplates: {
    title: 'CT template',
    importAction: 'Importēt no kataloga',
    importTitle: 'Importēt CT template no kataloga',
    importSubmit: 'Importēt',
    importError: 'Imports tika noraidīts',
    importHint: 'Materializācija kopē rootfs uz izvēlēto storage — kataloga fails paliek neskarts. Lai pievienotu jaunus failus, tie vispirms jāaugšupielādē katalogā.',
    sourceFile: 'CT template fails',
    sourceFileHint: 'Izvēlētā kataloga ct-rootfs faili, tikai gatavie',
    noFiles: 'Šajā katalogā nav neviena gatava ct-rootfs faila — jāaugšupielādē kāds no kataloga lapas',
    source: 'Avota fails',
    rootfsStorage: 'Rootfs storage',
    rootfsStorageHint: "Kur mīt izvilktais rootfs koks — storage ar failu sistēmu un pietiekami daudz brīvas vietas izvilktajam izmēram ar aptuveni 1 GiB rezervi (citādi imports neizdosies).",
    resources: 'Resursi',
    cores: 'vCPU',
    memoryMiB: 'Atmiņa (MiB)',
    cpuLimit: 'CPU ierobežojums',
    cpuLimitHint: 'Host kodolu ekvivalenti (piem., 1,5); tukšs = bez griestiem',
    cpuUncapped: 'bez griestiem',
    cpuWeight: 'CPU svars',
    hostname: 'Hostname',
    hostnameHint: 'Tukšs = CT nosaukums',
    nameservers: 'DNS nameserveri',
    dnsHint: 'Atdalīti ar komatu; tukšs = manto host serverus',
    searchDomains: 'DNS meklēšanas domēni',
    dnsInherited: 'Mantots no host',
    networks: 'Tīkli',
    nicSlot: 'NIC slots',
    phase: {
      materializing: 'Notiek materializācija',
      ready: 'Gatavs',
      deleting: 'Notiek dzēšana',
      error: 'Kļūda'
    },
    exportAction: 'Eksportēt katalogā',
    exportTitle: 'Eksportēt katalogā',
    exportSubmit: 'Eksportēt',
    exportError: 'Eksports tika noraidīts',
    exportHint: 'Iepako materializēto rootfs JAUNĀ ct-rootfs failā izvēlētajā katalogā — template paliek neskarts.',
    exportName: 'Faila nosaukums',
    exportNameHint: 'Tukšs = <template>-export-<n>',
    markCt: {
      action: 'Atgriezt par CT',
      confirmTitle: "Atgriezt '{name}' par CT?",
      confirmBody: 'Template pamet šo sarakstu un atgriežas CT sarakstā, atkal palaižams. Kamēr tas nav no jauna paaugstināts, no tā nevar izveidot CT.',
      confirm: 'Atgriezt par CT',
      moved: "'{name}' atkal ir CT — atrodams CT sarakstā."
    }
  },

  // OCI wave 1 (Annex Q — modelis tags-kā-branch): OCI tags ir branch
  // (kustīgs rādītājs), digests ir commit; atsvaidzināšana = "git fetch",
  // pull = atrisināt TAGAD, lejupielādēt TO digestu.
  oci: {
    registriesTitle: 'OCI registry',
    imagesTitle: 'OCI attēli',
    provider: 'Nodrošinātājs',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Vispārīgs',
    providerImmutableHint: 'Nodrošinātājs pēc izveides nav maināms — cits nodrošinātājs ir jauns registry.',
    url: 'URL',
    urlHintPreset: 'Aizpildīts pēc nodrošinātāja — jāpārraksta tikai spoguļserveriem.',
    urlHintRequired: 'Obligāts vispārīgiem registry: bāzes https:// adrese.',
    urlHintEcr: 'Obligāts: ECR galapunkti ir katram kontam un reģionam — priekšiestatījuma nav.',
    credential: 'Akreditācijas dati',
    credentialNone: 'Anonīma piekļuve',
    credentialHint: 'Keystore ieraksts ar lietotājvārdu un paroli; worker to atrisina lietošanas brīdī — nekad auth fails katram mezglam.',
    nameHint: 'Host tipa nosaukums (docker.io, registry.intra); unikāls scope ietvaros, nemaināms',
    addRegistry: 'Pievienot registry',
    addRegistryTitle: 'Pievienot OCI registry',
    verify: 'Pārbaudīt',
    verifyState: 'Pārbaude',
    verified: 'Pārbaudīts',
    verifyFailed: 'Neizdevās',
    neverVerified: 'Nekad nav pārbaudīts',
    registryInUseError: "'{name}' ir vēl reģistrēti repozitoriji — vispirms tie jādzēš.",
    repositories: 'Repozitoriji',
    repositoriesHint: 'Reģistrēšana novēro branch (OCI tagus) — neko nelejupielādē. Atsvaidzināšana atrisina katru novēroto branch un uztur reflog.',
    noRepositories: 'Šajā registry nav reģistrēts neviens repozitorijs.',
    registerRepository: 'Reģistrēt repozitoriju',
    repoPath: 'Ceļš',
    repoPathHint: "Repozitorija ceļš registry, piem., 'example' vai 'library/nginx'",
    branches: 'Branch',
    branchesHint: 'Novērotie branch (OCI tagi), atdalīti ar komatu — piem., 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Atrisināts TAGAD: pull lejupielādē to digestu, uz kuru branch norāda šodien.',
    refresh: 'Atsvaidzināt',
    deleteRepository: 'Dzēst repozitoriju',
    reflogCount: 'iepriekšējie: {n}',
    noResolutions: 'Nekad nav atsvaidzināts — nav novērota neviena atrisināšana.',
    refreshFailed: 'Pēdējā atsvaidzināšana neizdevās ({when})',
    loadError: 'Neizdevās ielādēt repozitorijus.',
    reference: 'Atsauce',
    digest: 'Digests',
    digestHint: 'sha256:… — precīzs attēls, bez branch (detached)',
    size: 'Izmērs',
    nodes: 'Mezgli',
    detached: 'detached',
    detachedHint: 'Lejupielādēts pēc digesta, bez branch — drift kontrole neattiecas.',
    pulledAt: 'Lejupielādēts',
    pull: 'Pull',
    pullTitle: 'Attēla pull',
    pullHint: 'Pre-warming, nekad priekšnosacījums: pull pēc branch atrisina TAGAD un lejupielādē TO digestu; pull pēc digesta ir detached.',
    pullError: 'Pull tika noraidīts',
    pullMode: 'Pull pēc',
    pullModeBranch: 'Branch (atrisināt tagad)',
    pullModeDigest: 'Digests (detached)',
    pullModeBranchHint: 'Godīgais noklusējums: tāpat kā apt install — vēlāk izpildīts atkārtoti, tas var dot citu attēlu.',
    pullModeDigestHint: 'Precīzs digests — atkārtojamība un rollback; atsakās no drift kontroles.',

    // Divu pogu raksts (#88, ratificēts 2026-07-30 vakarā): "no registry" ir
    // esošais vadītais pull, "no kataloga" materializē gatavu oci-image
    // arhīvu (air-gapped ceļš).
    importFromRegistry: 'Importēt no registry',
    importFromCatalog: 'Importēt no kataloga',
    importCatalogTitle: 'Importēt OCI attēlu no kataloga',
    importCatalogHint: 'Air-gapped ceļš: gatavs oci-image arhīvs (tar/tar.gz — docker-archive vai oci-archive) tiek materializēts attēlu glabātuvē ar atsauci catalog/<katalogs>/<fails>@<digests>; lietotnes to izmanto kā jebkuru citu attēlu. Arhīvi tiek augšupielādēti katalogos — šī sadaļa tikai importē.',
    importCatalogFile: 'Arhīvs',
    importCatalogFileHint: 'Izvēlētā kataloga gatavie oci-image faili.',
    importCatalogNoFiles: 'Šajā katalogā nav neviena gatava oci-image arhīva — jāaugšupielādē kāds no kataloga detaļām.',
    importCatalogError: 'Imports tika noraidīts',
    registry: 'Registry',
    repository: 'Repozitorijs',
    cacheMissing: 'Klastera OCI kešatmiņa nav konfigurēta — pull tiek noraidīts, kamēr nav iestatīts storage pūls.',
    setCache: 'Iestatīt kešatmiņu',
    setCacheTitle: 'Konfigurēt OCI kešatmiņu',
    setCacheHint: 'Klastera līmeņa NOKLUSĒJUMA pūls, kas mitina lejupielādēto attēlu blobus — scope to var pārrakstīt ar savu pūlu (lapa Scope). Maiņa nenotiek darbības laikā, neko nepārstartē un nepārvieto blobus: tie parādās no jauna slinki, nākamajā palaišanas vai lietošanas reizē.',
    cachePool: 'Storage pūls',
    changeCache: 'Mainīt kešatmiņu',
    changeCacheTitle: 'Mainīt OCI kešatmiņas pūlu',
    cacheCurrent: 'Klastera OCI kešatmiņa (noklusējums): {name}',
    sectionOverview: 'Pārskats',
    sectionRepositories: 'Repozitoriji',
    sectionExplore: 'Pārlūkot',
    exploreHint: 'Attālināta tiešsaistes meklēšana registry — Docker Hub pilnā apjomā (apraksts, lejupielādes, zvaigznes), citiem nodrošinātājiem cik nu iespējams. Atlasot rezultātu, var izlasīt tā pilno aprakstu un pārlūkot attālinātos tagus; no taga var pievienot atsauci TVirt repozitorijam.',
    exploreSearch: 'Meklēt',
    exploreUnsupported: 'Šis nodrošinātājs meklēšanu neatbalsta.',
    exploreNoResult: 'Nav atbilstoša repozitorija.',
    exploreNoTags: 'Šajā repozitorijā nav atbilstoša taga.',
    exploreOfficial: 'Oficiāls',
    explorePulls: 'Lejupielādes',
    exploreStars: 'Zvaigznes',
    exploreUpdated: 'Atjaunināts {when}',
    exploreLoadMore: 'Ielādēt vairāk',
    exploreSelectHint: 'Jāatlasa rezultāts: pilnais apraksts un attālinātie tagi ielādēsies šeit.',
    exploreNoDescription: 'No šī nodrošinātāja apraksts nav pieejams.',
    exploreTagsTitle: 'Attālinātie tagi',
    exploreTagFilter: 'Meklēt tagu',
    exploreAddToRepo: 'Pievienot repozitorijam',
    exploreAdded: '{path}:{tag} tagad tiek izsekots — skatīt sadaļu Repozitoriji.',
    addBranch: 'Pievienot branch',
    purgeRequiredTitle: "Dzēst '{name}' un tā attēlus?",
    purgeRequiredBody: 'Neviena lietotne šo repozitoriju neizmanto, bet lejupielādēti attēli vēl pastāv: dzēšana noņem arī to ierakstus, un kešatmiņas blob dati nonāk pie garbage collection.',
    purgeConfirm: 'Dzēst arī attēlus',
    providerSelectHint: 'Izvēlieties registry tipu: kartīte stāsta par presetu un lietojumu.',
    providerDesc: {
      dockerhub: 'Publiskais Docker registry: URL aizpildīts iepriekš, pilna meklēšana ar aprakstiem un skaitītājiem.',
      ghcr: 'GitHub Container Registry: URL aizpildīts iepriekš; konti lieto personal access token.',
      ecr: 'Amazon Elastic Container Registry: galapunkti katram kontam/reģionam — URL jānorāda.',
      quay: 'Red Hat Quay registry: URL aizpildīts iepriekš.',
      generic: 'Pašizvietots registry (Harbor, registry:2, …): https:// URL ir obligāts.'
    },

    // Standarta dialogs (kārta #156): attēla un registry detaļu lauki, ko
    // kolonnas nerādīja.
    layerCount: 'Slāņi',
    verifiedAt: 'Pēdējā pārbaude',
    verifyOk: 'Rezultāts',
    verifyMessage: 'Pārbaudes ziņojums',

    // Modelis #348/R39: attēls IR digests — saturs — un registry, repozitorijs un zars ir NOSAUKUMI, kas to sasniedz.
    head: 'Head',
    heads: 'Galvas pēc arhitektūras',
    listDigest: 'Saraksta digests',
    neverResolved: 'Nekad nav atrisināts',
    totalSize: 'Kopējais izmērs',
    reflogTitle: 'Atrisinājumu vēsture',
    usedBy: 'Izmanto',
    usageLockfile: 'lockfile',
    usageRunning: 'darbojas',
    evictable: 'izmetams',
    evict: 'Izmest no kešatmiņas',
    evictHeadTitle: 'Izmest {digest}?',
    evictHeadBody: 'Tas ir vismaz viena kolektora pašreizējais atrisinājums: izmest to ir likumīgi — tā ir tikai kešatmiņa, attālais branch to joprojām piedāvā — bet tam nekad nav jānotiek nejauši. Blob ir VIENS: izmešana iztukšo visus kolektorus, kas to koplieto.',
    evictConfirm: 'Tomēr izmest',

    arch: 'Arhitektūra',
    names: 'Nosaukumi',
    noNames: 'bez nosaukuma',
    views: 'Skati',
    lastView: 'pēdējais skats',
    evictLastViewTitle: 'Noņemt pēdējo atsauci uz {digest}?',
    evictLastViewBody: 'Šis ir pēdējais skats uz šo saturu: to noņemot, attēls beidz pastāvēt TVirt un baiti ({size}) tiek atbrīvoti. Tas ir modeļa docker image rm — nevis blakusefekts, bet pati darbība.',
    branchesTabHint: 'Šī repozitorija novērotie zari: katram šodienas galvas — pa vienai katrai arhitektūrai — atsvaidzinājumu hronoloģija un cik daudz tā nosaukto attēlu ir kešatmiņā. Atsvaidzināšana ir repozitorija «git fetch»: tā atrisina visus zarus uzreiz.',
    noBranches: 'Šajā repozitorijā netiek novērots neviens zars.',
    stopObserving: 'Pārtraukt zara novērošanu',
    pullBranch: 'Lejupielādēt kešatmiņā branch galvu (refresh atrisina, šis lejupielādē)',
    pullDigest: 'Lejupielādēt kešatmiņā šo digest',
    imageCount: 'Attēli',
    deleteBranchPurgeTitle: 'Atstāt {name} attēlus bez nosaukuma?',
    deleteBranchPurgeBody: 'Neviena lietotne nenosauc šo zaru, bet daži attēli ir sasniedzami tikai caur to: to dzēšot, tie paliek kešatmiņā bez nosaukuma, uzskaitīti repozitorija attēlu vidū un noņemami ar roku.',
    deleteBranchPurgeConfirm: 'Dzēst un atstāt attēlus bez nosaukuma',
    imagesTabHint: 'Šī repozitorija attēli — saturs, tas ir, digesti — redzami arī bez zara izvēles. Attēls ir unikāls klasterī: nosaukumu, kas to sasniedz, var būt vairāki.',
    noImages: 'Neviens šī repozitorija attēls nav materializēts kešatmiņā.',
    deleteRepositoryTitle: 'Dzēst {name}?',
    deleteRepositoryBody: 'Repozitorijs un tā zari pazūd kopā ar hronoloģiju. Attēli paliek kešatmiņā: tie zaudē tikai šo nosaukumu. Repozitoriju, ko nosauc lietotne, nevar dzēst.',
    provenanceCatalog: 'katalogs',
    refreshedAt: 'Atsvaidzināts',
    neverRefreshed: 'Nekad nav atsvaidzināts',
    sectionBranches: 'Zari',
    sectionImages: 'Attēli',
    repositoriesGovernedElsewhere: 'Šeit repozitorijus tikai aplūko: to reģistrēšana, atsvaidzināšana, zaru novērošana un attēlu noņemšana notiek sadaļā OCI attēli.',
    gotoImages: 'Uz OCI attēliem'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Podi',
    containers: 'Konteineri',
    instances: 'Instances',
    instancesTooltip: '{running} darbojas, {error} ar kļūdu',
    placement: 'Izvietojums',
    spread: 'sadalījums',
    ha: 'HA',
    templateRevision: 'revīzija',
    deleting: 'Tiek dzēsts',
    empty: 'Nav podu — izveidojiet lietotni (vienu konteineru) vai podu no CLI (create-pod).',
    openInstances: 'Atvērt instances',
    rollingRestart: 'Pakāpeniska restartēšana',
    scale: 'Mērogot',
    scaleTitle: 'Mērogot {name}',
    scaleHint: 'Instanču skaits (0–64): uz augšu aizņem zemāko brīvo kārtas numuru, uz leju atsauc augstāko, un tā pastāvīgie dati paliek.',
    scaleError: 'Mērogošana neizdevās',
    replicas: 'Replikas',
    deleteRunningError: '{name} darbojas — vispirms apturiet.',
    deleteInstancesIntro: 'Visas {count} instances tiks noņemtas.',
    stateRunning: 'Darbojas',
    stateStopped: 'Apturēts',
    editor: {
      createTitle: 'Izveidot Pod',
      create: 'Izveidot Pod',
      editTitle: 'Rediģēt Pod',
      nameHint: 'DNS-1123, ne vairāk kā 58 rakstzīmes — instances sauc <nosaukums>-<indekss>; nemainīgs pēc izveides.',
      restartPolicy: 'Restartēšanas politika',
      restartPolicyHint_always: 'Mezgls restartē katru izbeigušos konteineru ar eksponenciālu gaidīšanu (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Restartē tikai konteineru, kas beidzies ar kodu, kas nav nulle; iziešana 0 paliek mierā.',
      restartPolicyHint_never: 'Izbeidzies konteiners paliek, kāds ir — instance beidzas kā succeeded vai failed.',
      grace: 'Atlikšana (s)',
      graceHint: 'Apturēšanas SIGTERM → SIGKILL robeža.',
      hostname: 'Resursdatora nosaukums',
      hostnameHint: 'Tukšs = instances nosaukums.',
      hostnameDefault: 'instances nosaukums',
      sharePid: 'Koplietot PID nosaukumvietu starp konteineriem',
      containersIntro: 'Init konteineri darbojas līdz beigām, pēc kārtas, pirms konteineri startē; konteineri koplieto instances tīklu (viena IP, localhost savā starpā).',
      initContainers: 'Init konteineri',
      initAdd: 'Pievienot init konteineru',
      initHint: 'Katram jābeidzas ar 0; kļūme noved instanci kļūdā, un mezgls to atkārto ar gaidīšanu.',
      containerAdd: 'Pievienot konteineru',
      atLeastOne: 'Pod nepieciešams vismaz viens konteiners.',
      duplicateNames: 'Konteineru nosaukumiem Pod ietvaros jābūt unikāliem (ieskaitot init konteinerus).',
      containerName: 'Konteinera nosaukums',
      containerInvalid: 'Šis konteiners ir nepilnīgs: nosaukums (DNS-1123), attēls, montējumi uz deklarētiem sējumiem, skaitliski limiti un zonde.',
      command: 'Komanda',
      commandHint: 'Aizstāj attēla entrypoint — viens arguments rindā, nekad čaulas virkne.',
      args: 'Argumenti',
      argsHint: 'Viens rindā (attēla CMD, ja tukšs).',
      mounts: 'Montējumi',
      mountAdd: 'Pievienot montējumu',
      mountNoVolumes: 'Vispirms deklarējiet sējumu cilnē Krātuve.',
      readOnly: 'tikai lasāms',
      resources: 'Limiti',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (piem., 1.5)',
      memory: 'Atmiņa (MiB)',
      memoryHint: 'podman --memory',
      health: 'Dzīvotspējas zonde',
      healthCmd: 'Zondes komanda',
      healthCmdHint: 'Mezgls to izpilda konteinerā katrā uzraudzības taktī — viens arguments rindā; iziešana 0 = vesels.',
      healthTimeout: 'Noildze (s)',
      healthRetries: 'Mēģinājumi',
      healthRetriesHint: 'Secīgas kļūmes, pirms mezgls restartē konteineru.',
      ips: 'Statiskās adreses',
      ipsHint: 'Viena uz instanci, kārtas numuru secībā — mērogošana ārpus saraksta tiek noraidīta.',
      instance: 'instance',
      volumesHint: 'Sējumi pieder Pod; montēšanas ceļš — katram konteineram (cilne Konteineri).',
      spread: 'Izkliede',
      spreadHint_preferred: 'Instances dažādos mezglos, kad iespējams.',
      spreadHint_required: 'Instances dažādos mezglos, citādi mērogošana atsaka.',
      spreadHint_none: 'Tikai lēmējs.',
      ha: 'Augsta pieejamība (opt-in)',
      haHint: 'Katra pastāvīgā daļa koplietotā krātuvē; ja mezgls mirst, HA decider izveido instances no jauna citā dalībniekā (automātisks failover, kā HA VM).',
      yes: 'jā',
      no: 'nē'
    },
    detail: {
      container: 'Konteiners',
      actions: 'Darbības',
      ready: 'Gatavs',
      notReady: 'Nav gatavs',
      restarts: 'Restartēšanas',
      lastRestartAt: 'Pēdējā restartēšana:',
      backoffUntil: 'Atkārtot plkst.',
      stateAbsent: 'nav',
      stateRunning: 'darbojas',
      stateTerminated: 'izbeigts',
      stateWaiting: 'gaida',
      init: 'init',
      noInstances: 'Nav instanču (replikas 0).',
      ha: 'HA',
      haHint: 'Automātisks failover: ja mezgls mirst, HA decider izveido instanci no jauna citā dalībniekā (katra pastāvīgā daļa koplietotā krātuvē).',
      authority: 'Authority (mezgls)',
      homeless: 'bez authority',
      homelessHint: 'Atjaunošana no checkpoint atstāj authority ārpusē (#380): neviens mezgls to neapkalpo, kamēr nemērogosiet Pod (kaut vai līdz tam pašam repliku skaitam).',
      restartContainer: 'Restartēt tikai šo konteineru (pod paliek darbībā)',
      divergingHint: 'Šīs instances vēlamais stāvoklis atšķiras no Pod noklusējuma (PD-P19).',
      revisionLag: 'revīzija {applied} piemērota no {current}',
      updatedInstances: '{updated}/{desired} instances šajā revīzijā'
    }
  }
}
